<template>
  <div class="calendar-online">
    <div class="type-calendar h-48"><h2>予約申請</h2></div>

    <SelectCategory v-model="meetingData.category" v-if="currentStep === 'select-category'"/>

    <SetTitle v-show="currentStep === 'set-title'" v-model="meetingData.title"/>

    <SelectPharmacies v-show="currentStep === 'add-pharmacies'" v-model="meetingData.pharmacy"/>

    <TimePicker v-if="currentStep === 'time-picker'" :pharmacy="meetingData.pharmacy" v-model="meetingData.time"/>

    <Confirm v-show="currentStep === 'confirm'" :meeting="meetingData"/>

    <LastStep v-show="currentStep === 'last-step'"
      :meeting-category="meetingData.category"
      :meeting="meeting"
      :meeting-id="meetingId" />

    <Buttons
      :current-step="currentStep"
      :steps="steps"
      @changeStep="changeStep"
      :disable-next-step="disableNextStep" />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import MeetingsApi from '@/api/meeting'
import PharmaciesApi from '@/api/pharmacies'
import Calendar from '@/components/Calendar'
import SelectCategory from '@/components/meetings/create/SelectCategory'
import SetTitle from '@/components/meetings/create/SetTitle'
import SelectPharmacies from '@/components/meetings/create/SelectPharmacies'
import TimePicker from '@/components/meetings/create/TimePicker'
import Confirm from '@/components/meetings/create/Confirm'
import LastStep from '@/components/meetings/create/LastStep'
import Buttons from '@/components/meetings/create/Buttons'
import {apiErrorDialog} from '@/helpers'

export default {
  components: {
    Calendar,
    SelectCategory,
    SelectPharmacies,
    TimePicker,
    Confirm,
    LastStep,
    Buttons,
    SetTitle
  },
  data () {
    return {
      currentStep: 'select-category',
      steps: ['select-category', 'set-title', 'add-pharmacies', 'time-picker', 'confirm', 'last-step'],
      meetingData: {category: 1, title: '', pharmacy: null, time: {start: null, end: null}},
      meetingId: -1,
      meeting: {},
      dateSelected: null,
      showMeetingTimePicker: false,
      disableNextStep: true
    }
  },
  computed: {
    ...mapGetters({
      meetingCategoroies: 'meetings/categories'
    })
  },
  methods: {
    showErrorMessage (msg) {
      this.$message.error(msg)
    },
    async changeStep (step, back = false) {
      if (!back) {
        if (this.currentStep === 'select-category') {
          if (!this.meetingData.category) {
            this.showErrorMessage('薬局を選択してください')
            return false
          }
        } else if (this.currentStep === 'add-pharmacies') {
          if (!this.meetingData.pharmacy) {
            this.showErrorMessage('薬局を選択してください')
            return false
          }
        } else if (this.currentStep === 'time-picker') {
          if (!this.meetingData.time.start || !this.meetingData.time.end) {
            this.showErrorMessage('日程を選択してください')
            return false
          }
        } else if (this.currentStep === 'confirm') {
          await this.createMeeting()
        } else if (this.currentStep === 'last-step') {
          return this.$router.push({name: 'home'})
        }
      }
      this.currentStep = step
    },
    async createMeeting () {
      const loading = this.$loading.show()

      try {
        let meeting = {}
        meeting.title = this.meetingData.title
        meeting.category_id = this.meetingData.category
        meeting.pharmacy_id = this.meetingData.pharmacy.id
        meeting.start_at = this.meetingData.time.start.format('Y-MM-DD HH:mm:00')
        meeting.end_at = this.meetingData.time.end.format('Y-MM-DD HH:mm:00')
        const createdMeeting = await MeetingsApi.store(meeting)
          .catch((error) => {
            loading.hide()
            apiErrorDialog(this, error)
          })
        if (meeting.category_id === 1) {
          this.meetingId = createdMeeting.data.data.id
          this.meeting = createdMeeting.data.data
        }
      } catch (e) {
        console.log(e)
      }

      loading.hide()
    },
    async fetchPpPhamarcies () {
      const loading = this.$loading.show()
      const res = await PharmaciesApi.getAll({from_pp: true})
        .catch((error) => {
          loading.hide()
          apiErrorDialog(this, error)
        })
      if (res.data.data.length > 0) this.disableNextStep = false
      loading.hide()
    }
  },
  mounted () {
    this.fetchPpPhamarcies()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Meeting/CreateMedicationInstruction.vue